/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Turbine } from "./modelTurbine";

class ControllerTurbine extends ControllerModel {
    constructor() {
        super("ControllerTurbine");

        this.setNewNode = (callback) => {
            let turbine = new Turbine();
            turbine.decorate(callback);

            this.addNode(turbine);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let turbine = new Turbine();
            turbine.copyFrom(node);
            turbine.decorate(callback);
            this.addNode(turbine)
        }

        this.getProperties = async (node) => {
            let n = new Turbine();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Turbine();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerTurbine };